module.exports = __webpack_public_path__ + "static/media/basil-beef-uncropped.326a7e95.png";